// src/components/homepage/FeaturedCollections.js
import React, { useEffect, useRef } from 'react';
import { useCurrency } from '../../context/CurrencyContext';
import { useProducts } from '../../context/ProductContext';
import ProductCard from '../shop/ProductCard';
import { fadeIn } from '../../utils/gsapAnimations';
import SectionLoader from '../common/SectionLoader';

function FeaturedCollections() {
  const sectionRef = useRef(null);
  const { formatPrice } = useCurrency();
  const { products, loading, error } = useProducts();

  useEffect(() => {
    fadeIn(sectionRef.current, 0.3);
  }, []);

const featured = [...products].sort(() => 0.5 - Math.random()).slice(0, 4);
  if (loading) {
    return <SectionLoader message="Loading featured collections..." />;
  }

  if (error) {
    return (
      <div className="text-center py-10 text-red-500 font-montserrat">
        {error}
      </div>
    );
  }

  return (
    <div ref={sectionRef} className="py-12 px-4">
      <h2 className="text-3xl md:text-4xl font-lora font-semibold text-primary mb-6 text-center">
        Featured Collections
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
        {featured.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            formatPrice={formatPrice}
          />
        ))}
      </div>
    </div>
  );
}

export default FeaturedCollections;